import React, { useEffect, useRef, useState } from "react"; 
import { Chart } from "react-google-charts";
import { colorsList } from "../../helpers/colors";
import GetAppIcon from '@material-ui/icons/GetApp';

import { 
  applyDataFormatDefault, 
  applyDataFormatFive, 
  applyDataFormatFor, 
  applyDataFormatFor2,
  applyDataFormatOther, 
  applyDataFormatThree, 
  applyDataFormatTwo 
} from "./formatColumns/applyFormat";
import { defaultTextImage } from "../../configuration/variables";

const medias = {
  lx: "12",
  md: "12",
  xs: "12",
};

// [
//   ["RESPUESTA", "SI", "NO"],
//   ["New York City, NY", 8175000.32, 8008000.68],
//   ["Los Angeles, CA", 3792000, 3694000],
//   ["Chicago, IL", 2695000, 2896000],
//   ["Houston, TX", 2099000, 1953000],
//   ["Philadelphia, PA", 1526000, 1517000],
// ]

const defaultColors = colorsList;
const ChartCustom = ({
  dataChart,
  titles,
  mediaQueries = medias,
  titleChart = "",
  subTitle,
  colors = [], 
  applyFormat = "ONE",
  cleanHeader=false,
  sort=false,
  mathFilter='',
  questionCount=12,
  log=false,
  labels=[],
  completeColumns = true,
  applyLimit = true,
  addPercentage = true,
  referencias={},
  replace=false,
  order=[],
  chartComment='',
  chartCommentJsx=null,
  chartConfig={
    height: '60vh',
    chartArea: { width: "85%", height: '' }
  },
}) => {
  const imageRef = useRef();
  const canvasRef = useRef();
  const [stateChart, setStateChart] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const { lx, md, xs } = mediaQueries;
  // resolución de imagen por defecto.
  const imageResolution = { width: 1366, height: 768 }
 
  const createImageWithText = () => {
    // generar la imagen con el texto
    const currentCanvas = canvasRef.current;
    const ctx = currentCanvas.getContext("2d");
    ctx.drawImage(imageRef.current, 0, 20, imageResolution.width, imageResolution.height);
    // añadir texto a la imagen.
    ctx.font = "11px Arial";
    ctx.textAlign = "center";     
    ctx.fillText(defaultTextImage, imageResolution.width / 2, 15); 

    // fonto de la imagen.
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = '#fff'; // <- background color
    ctx.fillRect(0, 0, imageResolution.width, imageResolution.height);

    // descagr la imagen
    let a = document.createElement("a");
    let imageUrl = currentCanvas.toDataURL("image/jpg");
    a.href = imageUrl;
    a.target = "_blank";
    a.download = "grafico.png";
    // Trigger the download
    a.click();
  }

  useEffect(() => {
    if(log){
      console.log('stateChart: ', stateChart);
    }
  }, [stateChart]);

  useEffect(() => {
    setImageUrl(''); // cada vez que se el formato cambie, se actualizará la imagen de el gráfico.
    if(applyFormat === 'ONE'){
      const [headers, allColumns] = applyDataFormatDefault(
        dataChart, titles, mathFilter,
        addPercentage, replace, referencias, order
      );
      setStateChart([headers, ...allColumns]);
    }else if(applyFormat === 'TWO'){
      const [headers, allColumns] = applyDataFormatTwo(dataChart, cleanHeader, sort, referencias, addPercentage);
      setStateChart([headers, ...allColumns]);
    }else if(applyFormat === 'THREE'){
      const [headers, allColumns] = applyDataFormatThree(dataChart, labels, addPercentage);
      setStateChart([headers, ...allColumns]);
    }else if(applyFormat === 'FOR'){
      const [headers, allColumns] = applyDataFormatFor(dataChart, referencias, addPercentage, sort);
      setStateChart([headers, ...allColumns]);
    }else if(applyFormat === 'FOR2'){
      const [headers, allColumns] = applyDataFormatFor2(dataChart, referencias, addPercentage, sort);
      setStateChart([headers, ...allColumns]);
    }else if(applyFormat === 'FIVE'){
      const [headers, allColumns] = applyDataFormatFive(dataChart, referencias, completeColumns, addPercentage);
      setStateChart([headers, ...allColumns]);
    }else{
      const [headers, allColumns] =applyDataFormatOther(dataChart, questionCount, addPercentage);
      setStateChart([headers, ...allColumns]);
    }
  }, [dataChart]);

  // options: isStacked: true,
  return (
    <div className={`col-xl-${lx} col-md-${md} col-xs-${xs}`}>
      <h5>{titleChart}</h5>
      <div className="div-char">
        <div className="d-flex justify-content-between align-items-center">
          <h6>{subTitle}</h6>
          <button
            className="btn btn-sm fs-3" 
            onClick={ createImageWithText }
            style={{ background: '#53565A', color: 'white' }}
            title="Descargar gráfico (png)"
          >
            <GetAppIcon/>
          </button>
        </div>
        <div style={{ display: 'none' }}>
          <canvas 
            ref={ canvasRef } 
            width={ imageResolution.width } 
            height={ imageResolution.height }/>
          <img
            ref={ imageRef }
            alt="Gráficos"
            src={ imageUrl }
          />
        </div>

        <div style={{ position: 'relative', }} >
          <div style={{ position: 'absolute', visibility: 'hidden', left: '-1400px', bottom: '-100px' }} >
            <Chart
              width={`${imageResolution.width}px`}
              height={`${imageResolution.height}px`}
              chartType="ColumnChart"
              data={stateChart}
              loader={<div>Cargando</div>}
              chartEvents={[
                {
                  eventName: 'ready',
                  callback: (ChartRef) => {
                    if(!imageUrl) {
                      setImageUrl(ChartRef.chartWrapper.getChart().getImageURI());
                    }
                  },
                },
              ]}
              options={{
                // Prueba.
                annotations: {
                  textStyle: {
                    colors: colors.length === 0 ? defaultColors : colors,
                    fontSize: 13,
                  },
                  alwaysOutside: true
                },
                chartArea: { top: 50 },
                legend: { 
                  position: "top", 
                  alignment: "center",
                  textStyle: {
                    fontSize: 13,
                  },
                },
                colors: colors.length === 0 ? defaultColors : colors,
                hAxis: {
                  minValue: 0,
                  textStyle: {
                    fontSize: 13,
                  },
                },
                vAxis: {
                  minValue:0,
                  viewWindow: applyLimit ? {
                    min: 0,
                    max: 100,
                  } : {}
                }
              }}
              // For tests
              rootProps={{ "data-testid": "3" }}
            />
          </div>
        </div>

        {/* gráfico para mostrar los datos. */}
        <Chart
          height={chartConfig.height}
          chartType="ColumnChart"
          data={stateChart}
          loader={<div>Cargando</div>}
          options={{
            // Prueba.
            annotations: {
              textStyle: {
                colors: colors.length === 0 ? defaultColors : colors,
                fontSize: 13,
              },
              alwaysOutside: true
            },
            chartArea: { 
              top: 50,
              width: chartConfig.chartArea.width, 
              height: chartConfig.chartArea.height,  
            },
            legend: { 
              position: "top", 
              alignment: "center",
              textStyle: {
                fontSize: 13,
              },
            },
            colors: colors.length === 0 ? defaultColors : colors,
            hAxis: {
              minValue: 0,
              textStyle: {
                fontSize: 13,
              },
            },
            vAxis: {
              minValue:0,
              viewWindow: applyLimit ? {
                min: 0,
                max: 100,
              } : {}
            }
          }}
          // For tests
          rootProps={{ "data-testid": "3" }}
        />
        {chartComment && <p className="text-muted mb-0">{chartComment}</p>}
        {chartCommentJsx && chartCommentJsx}
      </div>
    </div>
  );
};

export default React.memo(ChartCustom);
